var _g, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaspa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M770.899 348.403c-83.93 46.080-171.718 88.141-256.467 133.376-86.854-52.832-171.834-107.661-257.754-161.549 81.478-43.482 167.642-88.954 248.87-128.23 89.427 51.2 175.578 105.67 265.35 156.403z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M223.482 365.12q133.261 78.4 264.064 158.976v307.667c-5.728 1.402-10.989-3.738-15.43-6.4-80.538-48.742-168.678-100.294-248.749-151.264q0.173-154.502 0.115-308.979z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M800.474 698.502c-82.88 46.643-174.17 91.648-257.754 133.376v-310.234c85.568-43.834 171.482-87.437 256.467-132.090 2.925 100.41 0.352 206.285 1.286 308.947z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M512 1024c-0.64 0.003-1.398 0.005-2.157 0.005-282.77 0-512-229.23-512-512s229.23-512 512-512c282.768 0 511.997 229.228 512 511.995v0c0 0.14 0 0.305 0 0.47 0 281.918-228.059 510.57-509.752 511.53h-0.092zM512 60.314c-0.567-0.003-1.237-0.004-1.907-0.004-249.463 0-451.693 202.23-451.693 451.693s202.23 451.693 451.693 451.693c249.463 0 451.693-202.23 451.693-451.693 0-0.001 0-0.002 0-0.002v0c0-0.145 0-0.317 0-0.489 0-248.694-201.204-450.394-449.71-451.198h-0.076z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaspa);
export default __webpack_public_path__ + "static/media/caspa.9e23077149b82dda4a4a115c8c1bc035.svg";
export { ForwardRef as ReactComponent };